module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "noMargin"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('div', {
    staticClass: "pageTitle",
    staticStyle: {
      "max-width": "100% !important",
      "width": "100% !important"
    }
  }, [_c('h2', [_vm._v("QUOTES REPORT")]), _vm._v(" "), _c('v-progress-circular', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.excelLoading == true),
      expression: "excelLoading == true"
    }],
    staticClass: "pt-3 loginLoader",
    staticStyle: {
      "display": "block",
      "float": "left !important",
      "margin-left": "72% !important",
      "margin-top": "12px"
    },
    attrs: {
      "indeterminate": "",
      "width": 3,
      "size": 20,
      "color": "grey"
    }
  }), _vm._v(" "), (_vm.quotesLoaded == true && _vm.objAuthorize.privileges.indexOf('CAN_SEARCH_ARCHIVE') != -1) ? _c('v-btn', {
    staticClass: "elevation-5",
    attrs: {
      "color": "info"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncShowArchives()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("search")]), _vm._v("SEARCH ARCHIVED ")]) : _vm._e(), _vm._v(" "), (_vm.quotesLoaded == true && _vm.objAuthorize.privileges.indexOf('CAN_SUMMARY_REPORTING') != -1) ? _c('v-btn', {
    staticClass: "elevation-5",
    attrs: {
      "color": "info"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncShowSummaryReporting.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("summarize")]), _vm._v("SUMMARY REPORTING ")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.quotesLoaded == true && _vm.excelLoading == false),
      expression: "quotesLoaded == true && excelLoading == false"
    }],
    staticClass: "elevation-5",
    attrs: {
      "color": "info"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncExportQuotes.apply(null, arguments)
      }
    }
  }, [_c('img', {
    staticClass: "customIcon",
    attrs: {
      "src": require("../../shared/assets/images/icons/csv.svg"),
      "width": "16"
    }
  }), _vm._v("EXPORT TO EXCEL")]), _vm._v(" "), (_vm.quotesLoaded == true) ? _c('v-btn', {
    staticClass: "elevation-5",
    attrs: {
      "color": "info"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncShowColumns.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("view_column")]), _vm._v("MANAGE COLUMNS")]) : _vm._e()], 1)])], 1)], 1)
},staticRenderFns: []}